import { observer } from "mobx-react-lite";
import { videoPlayerService } from "../../services/video-player/VideoPlayerService";
import React, { useEffect, useMemo, useState } from "react";
import { useTheme } from "../../services/theme-service/ThemeService";
import ReactPlayer from "react-player";
import { translationService } from "../../services/translation/TranslationService";
import LoadingSpinner from "../loading-spinner/LoadingSpinner";

export default observer(function Player(props:{children?:any, enableControls?: boolean}) {
    const { themeClass } = useTheme();
    const {
        player,
        video,
        isVideoPlaying,
        aVideoIsLoaded: videoWasLoaded,
        handleProgress,
        handleDuration,
        isPictureInPicture,
        cancelDetachVideo,
        videoUrl,
        videoProgress,
        setVideoCanPlay,
        isVideoPositionProgress,
        clearVideoPositionProgress,
        videoPlayerTimestampsLoaded,
        videoWidth,
        videoHeight
    } = videoPlayerService;

    const [videoUrlWithInitialProgress, setVideoUrlWithInitialProgress] = useState("");
    
    const videoCanPlay = useMemo(
        () => videoWasLoaded && videoPlayerTimestampsLoaded,
    [videoPlayerTimestampsLoaded, videoWasLoaded]);

    useEffect(() => {
        if (videoCanPlay || (isVideoPositionProgress && videoCanPlay)) {
            setVideoUrlWithInitialProgress(`${videoUrl}#t=${videoProgress}`);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [videoUrl, videoCanPlay, isVideoPositionProgress]);

    useEffect(() => {
        setVideoCanPlay(!!videoCanPlay);
    }, [videoCanPlay, setVideoCanPlay]);

    useEffect(() => {
        return () => {
            setVideoCanPlay(false);
            clearVideoPositionProgress();
        };
    }, [setVideoCanPlay, clearVideoPositionProgress]);

    return (
        <div
            ref={player}
            className={themeClass(["video-player"], [isPictureInPicture ? "detached-mode" : ""])}
            style={{ width: "auto", height: "auto" }}
        >
            {!videoCanPlay && <LoadingSpinner spinnerOnly />}
            {videoCanPlay && (
        <>
            <ReactPlayer
                id={"my-video"}
                ref={video}
                url={videoUrlWithInitialProgress}
                playing={isVideoPlaying}
                width={videoWidth}
                height={videoHeight}
                onProgress={handleProgress}
                onDuration={handleDuration}
                onDisablePIP={cancelDetachVideo}
                controls={props.enableControls}
            />
            {props.children}
            {isPictureInPicture && (
            <div className="video-player-detached-text">
                {translationService.translate("damages.DamagesVideo.video-is-detached")}
            </div>
          )}
        </>
      )}
    </div>
    )
})